import HeaderMenu from './HeaderMenu'

export default function HeaderDesktop() {
  return <HeaderMenu />
}
